import { render, staticRenderFns } from "./siteDirectMining.vue?vue&type=template&id=38804708&scoped=true"
import script from "./siteDirectMining.vue?vue&type=script&lang=js"
export * from "./siteDirectMining.vue?vue&type=script&lang=js"
import style0 from "./siteDirectMining.vue?vue&type=style&index=0&id=38804708&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38804708",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38804708')) {
      api.createRecord('38804708', component.options)
    } else {
      api.reload('38804708', component.options)
    }
    module.hot.accept("./siteDirectMining.vue?vue&type=template&id=38804708&scoped=true", function () {
      api.rerender('38804708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/directPurchaseSpecialPrice/directPurchassSpecialchild/siteDirectMining.vue"
export default component.exports